import { render, staticRenderFns } from "./ResearchMPlotBitmap.vue?vue&type=template&id=6ea6c5ea&"
import script from "./ResearchMPlotBitmap.vue?vue&type=script&lang=js&"
export * from "./ResearchMPlotBitmap.vue?vue&type=script&lang=js&"
import style0 from "./ResearchMPlotBitmap.vue?vue&type=style&index=0&id=6ea6c5ea&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea6c5ea')) {
      api.createRecord('6ea6c5ea', component.options)
    } else {
      api.reload('6ea6c5ea', component.options)
    }
    module.hot.accept("./ResearchMPlotBitmap.vue?vue&type=template&id=6ea6c5ea&", function () {
      api.rerender('6ea6c5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchMPlotBitmap.vue"
export default component.exports